import {Button, Layout, Tabs} from 'antd';
import {React, useState} from 'react';
import appColors from '../../style/theme';
import ResultT1 from './ResultT1';
import ResultT2 from './ResultT2';

const {Content} = Layout;

const ResultTabs = () => {
  const [TAUno, setTAUno] = useState('white');
  const [GAUno, setGAUno] = useState(appColors['ColorX']);
  // others
  const [TUno, setTUno] = useState(appColors['ColorX']);
  const [GUno, setGUno] = useState(appColors['ColorG2']);

  const changeColor1 = (key) => {
    if (key === 'uno') {
      setTAUno('white');
      setGAUno(appColors['ColorX']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
    } else if (key === 'dos') {
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno('white');
      setGUno(appColors['ColorX']);
    }
  };
  const items_ = [
    {label: <Button style={{height: '13vh', top: '2.3vh', fontSize: '3vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TAUno, fontWeight: 'bold', borderColor: GAUno, background: GAUno}}>Effect of the nucleic<br/>acid refinement</Button>, key: 'uno', children: <ResultT1/>},
    {label: <Button style={{height: '13vh', top: '2.3vh', fontSize: '3vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TUno, fontWeight: 'bold', borderColor: GUno, background: GUno}}>Effect of temperature and<br/>ionic conditions</Button>, key: 'dos', children: <ResultT2/>},
  ];
  return (
    <Layout style={{margin: '-5.2vh 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{padding: '2vh', background: 'transparent'}}>
        <Tabs
          tabBarGutter='4vh'
          defaultActiveKey="1"
          size='large'
          items={items_}
          onTabClick={changeColor1}
        />
      </Content>
    </Layout>
  );
};

export default ResultTabs;
